import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=4b3a1b26&scoped=true"
import script from "./realtime.vue?vue&type=script&lang=js"
export * from "./realtime.vue?vue&type=script&lang=js"
import style0 from "./realtime.vue?vue&type=style&index=0&id=4b3a1b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3a1b26",
  null
  
)

export default component.exports